export default __webpack_public_path__ + "static/media/tj.393ded3d.svg";